import { AvatarStack } from "@productlane/ui"

import type { PeopleCompany } from "./people-columns"

interface Props {
	companies: PeopleCompany[]
}

export const PeopleCompanyCell = ({ companies }: Props) => {
	const [lead, ...rest] = companies

	if (!lead) return null

	return (
		<div className="flex min-w-0 items-center gap-2">
			<AvatarStack
				avatars={companies.map((company) => ({
					name: company.label,
					image: company.logoUrl,
				}))}
				size="xxs"
				slice={3}
				roundness="md"
				ringClassName="ring-gray-25 dark:ring-gray-900"
			/>
			<span className="truncate">{lead.label}</span>
			{rest.length > 0 && (
				<span className="flex-none text-tertiary">+{rest.length}</span>
			)}
		</div>
	)
}
